
	import ModeloUpdate from '@/views/paginas/sigap/modelos/ModeloUpdate.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Disciplina } from "@/views/paginas/sigap/turma/disciplinas/Disciplina"; 
	import $ from "jquery"   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import EixoService from   "@/service/v1/sigap/EixoService"  
	  
    @Options({
        name: "DisciplinaEdicao",
        components: {   },  
        emits: [  'update-disciplina-alterado'],  
    }) 
    export default class DisciplinaEdicao extends ModeloUpdate {
              
        
        public eixoService = new EixoService();

        async created() {  
            this.campos =  Disciplina.campos();  
            if(this.modelo != null){
                await this.buscarEixo();
                await this.buscarStatus();
                this.modeloAlterado();
            }  
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
 
        public async buscarEixo(){   
            await this.eixoService.getAll( "take=100&turmaId=" +  this.modelo.turmaId ).then(response =>{ 
               this.campos.unshift(
                    {
                        nome: "eixoId",
                        type: "select",
                        label: "Eixo",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.data.map((item) => { return { value: item.id, label: item.descricao } })
                    },
                );
            });
        }
 
        public async buscarStatus(){   
            await this.service.getStatus( ).then(response =>{ 
               this.campos.unshift(
                    {
                        nome: "status",
                        type: "select",
                        label: "Status",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }

        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));    
                    this.formulario.tipo = this.formulario.tipo.id;
                    this.formulario.status = this.formulario.status.id;
                })
                .catch(error => {
                    this.formulario = { };  
                });   
            } 
        }
 
        public sucesso(){  
            this.$emit("update-disciplina-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
        
    } 
